import ParsedText from './ParsedText';

export default ParsedText;
